module.exports = __webpack_public_path__ + "static/media/logo-ba.8e755823.jpg";